<template>
  <div>
    <img @click="$emit('close')" src="https://cdn.purplewave.ai/legacy/close.svg" class="icon icon-sm float-right" />

    <small>
      Répondre à <strong>{{ toUser }}</strong
      >...</small
    >
    <br />

    <small>
      <em>{{ toText }}</em>
    </small>
    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: "ReplyTo",
  props: {
    toUser: {
      type: String,
      default: null,
    },
    toText: {
      type: String,
      default: null,
    },
  },
};
</script>
